import { createReducer } from '@reduxjs/toolkit';
import { setCoorporateProfile, ICoorporateProfileResponse, setAccountRDL } from '../actions/CorporateProfileAction';

const initialState: ICoorporateProfileResponse = {
    companyName: '-',
    companyEmail: '-',
    picFullname: '-',
    phoneNumberPic: '-',
    accountType: '',
    dataAccountBalance: {
        vaBankCode: '',
        vaName: '',
        vaNumber: '',
        vaBank: '',
        methodPayment: 0
    }
};

const coorporateProfileReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setCoorporateProfile, (state, action) => ({
            ...state,
            companyName: action.payload.companyName,
            companyEmail: action.payload.companyEmail,
            picFullname: action.payload.picFullname,
            phoneNumberPic: action.payload.phoneNumberPic,
            accountType: action.payload.accountType,
            dataAccountBalance: action.payload.dataAccountBalance,
            dataAccountBalanceIM: action.payload.dataAccountBalanceIM,
        }))
        .addCase(setAccountRDL, (state, action) => ({
            ...state,
            vaBankCode: action.payload.vaBankCode,
            vaName: action.payload.vaName,
            vaNumber: action.payload.vaNumber,
            vaBank: action.payload.vaBank,
            methodPayment: action.payload.methodPayment
            // dataAccountBalance: action.payload,
        }))
        .addDefaultCase((state) => ({ ...state }));
});
export default coorporateProfileReducer;
